import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  heroVideo: {
    width: `min(100vw, ${theme.limits.max})`,
    height: "auto",
    display: "block",
    position: "relative",
    boxSizing: "border-box",
    "&:focus": {
      padding: "1px",
      border: `1px solid ${theme.palette.darkPurple}`,
    }
  },
  heroVideo_image: {
    width: `min(100vw, ${theme.limits.max})`,
    height: "auto",
    position: "absolute",
    zIndex: "-1"
  },
  heroVideo_video: {
    width: `min(100vw, ${theme.limits.max})`,
    height: "100%",
    zIndex: 5
  },
  heroVideo_divider: {
    width: "100%",
    zIndex: 10
  },
  heroVideo_divider_margin: {
    height: "2rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "4rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "3rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      height: "4rem",
    },
  }
}));
